// Reducers/studentDetailsReducer.js

import {
  FETCH_STUDENT_DETAILS_REQUEST,
  FETCH_STUDENT_DETAILS_SUCCESS,
  FETCH_STUDENT_DETAILS_FAILURE,
} from "../Actions/types";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const studentDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STUDENT_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STUDENT_DETAILS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_STUDENT_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default studentDetailsReducer;
